// @flow

import React from "react";
import ReactSelect from "react-select";
import Creatable from "react-select/lib/Creatable";
import AsyncSelect from "react-select/lib/Async";
import cx from "classnames";
import { getClassName, addModifierTo } from "ui-kit/utils/component";
import "./Select.scss";

type Props = {
  className?: string,
  input?: any,
  className?: string,
  white?: boolean,
  bigArrow?: boolean,
  required?: boolean,
};

const ccn = getClassName("Select");

export default (props: Props) => {
  const {
    input,
    options,
    name,
    id,
    selectedValue,
    onInputChange,
    className,
    white,
    bigArrow,
    required,
    placeholder,
    creatable,
    async,
    ...rest
  } = props;

  const modify = addModifierTo(ccn());

  const classes = cx(ccn(), {
    [modify("white")]: white,
    [modify("required")]: required,
    [modify("bigArrow")]: bigArrow
  }, className);

  if(input.value !== selectedValue) {
    input.value = selectedValue
  }

  return (
    <React.Fragment>
      {(!creatable && input) &&
      (<ReactSelect
        classNamePrefix={classes}
        id={id}
        name={name}
        options={options}
        value={selectedValue}
        onChange={(value) => { input.onChange(value);}}
        onFocus={() => {}}
        onInputChange={(value) => { onInputChange(value) }}
        selectedValue={selectedValue}
        clearable={false}
        placeholder={placeholder || ""}
        {...input}
        {...rest}
      />)
      }
      {(input && creatable) &&
      (<Creatable
        {...input}
        isClearable={true}
        classNamePrefix={classes}
        id={id}
        name={name}
        options={options}
        onBlur={() => {}}
        defaultInputValue={""}
        clearable={true}
        onFocusResetsInput={false}
        onBlurResetsInput={false}
        value={""}
        placeholder={input.value && input.value.label}
      />)
      }
      {(input && async) &&
      (<AsyncSelect
        {...input}
        {...props}
        isClearable={true}
        classNamePrefix={classes}
        id={id}
        name={name}
        options={options}
        onBlur={() => {}}
        defaultInputValue={""}
        clearable={true}
        onFocusResetsInput={false}
        onBlurResetsInput={false}
        placeholder={input.value && input.value.label}
      />)
      }
      {!input &&
      (<ReactSelect
        classNamePrefix={classes}
        id={id}
        name={name}
        options={options}
        defaultValue={selectedValue}
        clearable={false}
        placeholder={placeholder || ""}
        {...rest}
      />)
      }
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/ui-kit/components/select/Select.js